import { useGetUserLimits } from '../useGetUserLimits';

export const useJobLimit = () => {
  const { jobLimit } = useGetUserLimits();

  return jobLimit;
};
